import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
//import Helmet from 'react-helmet';
//import { push } from 'react-router-redux';
import * as authActions from '../../redux/modules/auth';
import * as commonActions from './../../actions/commonActions';
import * as reportActions from './../../actions/reportActions';
import * as instrumentListActions from './../../actions/instrumentListActions';
import i18next from 'i18next';
import { applyStyle, getCountofTableRows,applyToHover, setDirection } from './../../utils/utils';
import { withStyles } from '@material-ui/core/styles';
import {
  SortingState,
  IntegratedSorting,
  PagingState,
  IntegratedPaging,
  SearchState,
  IntegratedFiltering
} from '@devexpress/dx-react-grid';
import {
 Grid,
 Table,
 TableHeaderRow,
 SearchPanel,
 Toolbar,
 TableColumnReordering,
 DragDropProvider,
 TableColumnVisibility,
 ColumnChooser
} from '@devexpress/dx-react-grid-bootstrap4';
import { PagingPanel } from '@devexpress/dx-react-grid-material-ui';
import Modal from 'react-modal';
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import '../../theme/styles/reactstrap.css';
var styles=require('./Report.less');
import { DropdownButton, MenuItem, Button } from 'react-bootstrap';
import DateSelector from './../DateSelector/DateSelector';
import { getSelectedDate } from './../../utils/utils'; //import
import moment from 'moment';
import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
let compareRate = (a, b) => {
  let result;
    if (numeral(a)._value < numeral(b)._value) {
      result = -1;
    }else{
      result = 1;
    }
    return result;
};
let defAccFlag = true;
let fileName = "Outstanding Fixing Order Report";

const elementsData = [
  {"classNames":"onlinefilterBar", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"onlineOrdTable", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"fltrBarInner", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"reportsDropdown", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"dropdown-toggle", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"caret", "elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"dropdown-menu", "elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"dropDownList", "elementType":"tag", "applyTo":"all", "tagNames":"a"},
  {"classNames":"reportTblBg", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"glyphicon", "elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"material-icons", "elementType":"normal", "applyTo":"all", "tagNames":"i"},
  {"classNames":"reportsTblGrid", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"form-control", "elementType":"tag", "applyTo":"all", "tagNames":"input"},
  {"classNames":"oi-eye", "elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"text-muted", "elementType":"normal", "applyTo":"all", "tagNames":"big", "parent":"dx-g-bs4-fixed-block"},
  {"classNames":"", "elementType":"tag", "applyTo":"all", "tagNames":"th", "parent":"reportsTbl"},
  {"classNames":"mdlWrap", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"dx-g-bs4-table", "elementType":"normal", "applyTo":"all", "tagNames":"table"},
  {"classNames":"dx-g-bs4-header-cell", "elementType":"tag", "applyTo":"all", "tagNames":"th"},
  {"classNames":"dx-g-bs4-table-cell", "elementType":"tag", "applyTo":"all", "tagNames":"td"},
  {"classNames":"noDataCell", "elementType":"tag", "applyTo":"all", "tagNames":"td"},
  {"classNames":"pagingPanelDiv", "elementType":"tag", "applyTo":"all", "tagNames":"span"},
  {"classNames":"closeBtn" ,"elementType":"normal", "applyTo":"single", "tagNames":"div"},
];

const directionData=[
  {"classNames":"commonGoBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"onlDrpdownDiv", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"btnText", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"dropdown-menu", "elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"reportsTblGrid", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"allExportFilter", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
];

@connect(
  state => ({
    fixOrdTbleData: state.dashboardRoot.reportReducer.fixOrdTbleData,
    userDetail:state.auth.userDetail,
    socketDataStatic:state.dashboardRoot.instrumentListReducer.socketDataStatic,
    selectedLang:state.dashboardRoot.commonReducer.selectedLang,
    language:state.dashboardRoot.commonReducer.language,
    selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
    selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
    fixingEvents:state.dashboardRoot.dashboardReducer.fixingEvents,
    defAcc: state.dashboardRoot.dashboardReducer.defAcc,
    ACD: state.auth.ACD,
    DFA: state.auth.DFA,
    openCalender: state.dashboardRoot.commonReducer.openCalender,
    stockCodeList:state.dashboardRoot.dashboardReducer.stockCodeList
  }),{
  ...reportActions,
  ...instrumentListActions,
  ...commonActions
})

export default class FixingOrdersReport extends Component {
  static propTypes = {
    fixOrdTbleData: PropTypes.object,
    loadFixingReport: PropTypes.func,
    socketDataStatic: PropTypes.array,
    generateFixReportPdf:PropTypes.func,
    ACD: PropTypes.object,
    DFA: PropTypes.object,
    trdPanelData: PropTypes.object,
    getInvoice: PropTypes.func,
    openCalender:PropTypes.boolean,
    onClickCalender:PropTypes.func,
  }

  constructor(props){
    super(props);
    this.state = {
      selectedAccountName: this.props.DFA.D,
      selectedAccount:this.props.DFA.C,
      cmdtyList:[],
      selectedFixing:'',
      selectedFixingCode:'',
      selectedFixingTime:'',
      selectedCmdtyId:'',
      selectedCmdty:'',
      stkList:[],
      selectedStkCode:'',
      currentDate: new Date().toLocaleDateString('en-US'),
      startDate: new Date().toLocaleDateString('en-US'),
      endDate: new Date().toLocaleDateString('en-US'),
      orderType: 'outstanding',
      orderTypeKey:'O',
      fixEventTime: '',
      fixEventTimeKey:'',
      createdByKey:2,
      createdBy:'createdByAll',
      isRefreshDisabled : true,
      isClearFixingRpt:false,
      id:'today',
      keyValue:'fixingOrderReport',
      reportsRowsCount:0,
      outfixOrdColumnExtensions: [],
      pageSizes: [10, 15, 20, 0],
      searchValue:'',
      HiddenOutstandingTableCol:[],
      HiddenFillTableCol:[],
      HiddenCancelledTableCol:[],
      stkCodeList:[],
      accountList:Array.from(this.props.ACD.values()),
      COM:null,
      qty_type:'',
      showRptDialog:false,
      fixDateType:"ALL",
      fixingDateTypeHeading:"all",
      ranges: {
        [i18next.t('today')]: [
          moment(), moment()
        ],
        [i18next.t('yesterday')]: [
          moment().subtract(1, 'days'),
          moment().subtract(1, 'days')
        ],
        [i18next.t('last7Days')]: [
          moment().subtract(6, 'days'),
          moment()
        ],
        [i18next.t('last30Days')]: [
          moment().subtract(29, 'days'),
          moment()
        ],
        [i18next.t('thisMonth')]: [
          moment().startOf('month'), moment().endOf('month')
        ],
        [i18next.t('lastMonth')]: [
          moment().subtract(1, 'month').startOf('month'),
          moment().subtract(1, 'month').endOf('month')
        ]
      },
      integratedSortingColumnExtensions: [
        {columnName:'price', compare:compareRate, align:'right'},
        {columnName:'qty', compare:compareRate, align:'right'}
      ],
      Outstandingcols:["placedBy","orderNo","fixingDate","fixingEvent","deal_type","cmdtyPair","qty","ord_stk_code","remarks"],
      Filledcols:["placedBy","orderNo","fixingEvent","deal_type","cmdtyPair","filledTime","filledQty","ord_stk_code",'filledBy', "price","docNo","remarks"],
      Cancelledcols:["placedBy","orderNo","fixingEvent","deal_type","cmdtyPair","cancelledTime","cancelledQty","ord_stk_code", "cancelledBy", "remarks"],
    }
    this.onChangeHiddenOutstandingTableCol = this.onChangeHiddenOutstandingTableCol.bind(this);
    this.onChangeHiddenFillTableCol = this.onChangeHiddenFillTableCol.bind(this);
    this.onChangeHiddenCancelledTableCol = this.onChangeHiddenCancelledTableCol.bind(this);
    this.onChangeSearchValue = this.onChangeSearchValue.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
  }

  componentWillMount() {
    let outColsExtension =[];
    outColsExtension = [
      {columnName:'price',align: 'right', width:500}
    ]
    this.setState({outfixOrdColumnExtensions: outColsExtension});
    const locale = locale;
    this.setState({
      locale: {
        'format': 'DD-MM-YYYY',
        applyLabel: i18next.t('apply'),
        cancelLabel: i18next.t('cancel'),
        customRangeLabel:  i18next.t('customRange'),
        daysOfWeek: [
          i18next.t("su"),i18next.t("mo"),i18next.t("tu"),i18next.t("we"),i18next.t("th"),i18next.t("fr"),i18next.t("sa")
        ],
        monthNames:[
          i18next.t("jan"),i18next.t("feb"),i18next.t("mar"),i18next.t("apr"),i18next.t("may"),i18next.t("jun"),i18next.t("jul"),  i18next.t("aug"),i18next.t("sep"),i18next.t("oct"),i18next.t("nov"),i18next.t("dec")
        ]
      },
    });
  }

  componentDidMount() {
      //console.log("fixingOrders "+JSON.stringify(this.props.fixingEvents));
    const thisComponent = ReactDOM.findDOMNode(this);
    // //const allCssStyleRules = this.props.selectedCssColorTheme;
    // applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
      {"elmToHover":thisComponent.getElementsByClassName('closeBtn')[0], "classNames":"closeBtn"},
      {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},
    ];
   // //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    const accountlen=this.state.accountList.length;
    for(let i=0;i<accountlen;i++){
      const account=this.props.DFA.D;
      this.setState({fixeAcc_opt: account});
    }
    this.setState({selectedAccount:this.props.DFA.C});
    this.setState({createdBy:"createdByAll"});
    this.setState({createdByKey:'2'});
    this.setState({stkCodeList:this.props.stockCodeList,qty_type:this.props.stockCodeList[0].unit_code});
    this.setState({COM:null});
    this.setState({selectedFixingCode:this.props.fixingEvents[0].FC})
    this.setState({cmdtyList:this.props.fixingEvents[0].IID})
    this.setState({selectedFixing:this.props.fixingEvents[0].FN});

    // check empty array for custom instruments
    if (this.props.fixingEvents[0].IID.length !== 0) {
      this.setState({selectedCmdtyId: this.props.fixingEvents[0].IID[0].ID});
      this.setState({selectedCmdty: this.props.fixingEvents[0].IID[0].DESC});
      this.props.loadFixingReport(this.props.fixingEvents[0].FC, moment(new Date().toLocaleDateString('en-US')).format('DD-MM-YYYY'), moment(new Date().toLocaleDateString('en-US')).format('DD-MM-YYYY'), this.props.fixingEvents[0].IID[0].ID, 'O', 'D',this.props.DFA.C, '2','OZ',this.state.fixDateType);
    } else {
      this.setState({selectedCmdtyId: ''});
      this.setState({selectedCmdty: ''});
      this.props.loadFixingReport(this.props.fixingEvents[0].FC, moment(new Date().toLocaleDateString('en-US')).format('DD-MM-YYYY'), moment(new Date().toLocaleDateString('en-US')).format('DD-MM-YYYY'), this.props.fixingEvents[0].IID, 'O', 'D',this.props.DFA.C, '2','OZ',this.state.fixDateType);
    }
    // FixingCode,startDate,endDate,IID,orderType,fixEventTimeKey,account,createdBy,qtyType
    
    // console.log("this.props.fixingEvents[0].IID[0].ID" +this.props.fixingEvents[0].IID[0].ID);
  }

  getValidFixingEvents=()=>{
    try{
      this.setState({ loadtableflag: true });
      this.setState({ isRefreshDisabled : true });
      //setTimeout(() => this.setState({ loadtableflag: true }), 900);
      this.setState({orderTypeKey:this.state.orderTypeKey});
      // FixingCode,startDate,endDate,IID,orderType,fixEventTimeKey,account,createdBy,qtyType
      this.props.loadFixingReport(this.state.selectedFixingCode,moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'),this.state.selectedCmdtyId,this.state.orderTypeKey,this.state.fixEventTimeKey, this.state.selectedAccount,this.state.createdByKey,this.state.qty_type,this.state.fixDateType);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'getValidFixingEvents', component:"FixingOrdersReport"});
    }
  }
  // componentDidUpdate(prevProps){
  //   // if(prevProps.OnlinetbleData !== this.props.OnlinetbleData){
  //   //   this.refs.orderonlineTbl.reset();
  //   // }
  //   const thisComponent = ReactDOM.findDOMNode(this);
  //   //const allCssStyleRules = this.props.selectedCssColorTheme;
  //   applyStyle(thisComponent, allCssStyleRules, elementsData);
  // }

  componentWillReceiveProps(nextProps){
    const thisComponent = ReactDOM.findDOMNode(this);
    // //const allCssStyleRules = this.props.selectedCssColorTheme;
    // applyStyle(thisComponent, allCssStyleRules, elementsData);
    // setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   applyStyle(thisComponent, allCssStyleRules, elementsData);
    //   const hoverElementsClassNames = [
    //     {"elmToHover":thisComponent.getElementsByClassName('closeBtn')[0], "classNames":"closeBtn"},
    //     {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},
    //   ];
    //   //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    // };
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
      let obj1 = {
        cmdtId: 'All',
        cmdtDesc: i18next.t('allPairs')
      };
      var obj= this.state.cmdtyList;
      if(obj.findIndex(x => x.cmdtId=='All') === -1){
        obj.unshift(obj1);
      }else{
        var index = obj.findIndex(x => x.cmdtId=='All');
        obj.splice(index,1);
        obj.unshift(obj1);
      }
      this.setState({cmdtyList: obj});
    }

    if(this.props.isSearch !== nextProps.isSearch){
      this.setState({ loadtableflag: false });
      this.setState({ isRefreshDisabled : false });
    }

    if(this.state.isClearFixingRpt !== this.props.isClearFixingRpt){
      this.setState({ isClearFixingRpt: true });
      this.setState({ loadtableflag: true });
      this.setState({isRefreshDisabled:true});
      // this.setState({startDate: new Date().toLocaleDateString('en-US')});
      // this.setState({endDate:new Date().toLocaleDateString('en-US')});
      // this.setState({currentDate: new Date().toLocaleDateString('en-US')});
      // this.setState({id:'today'});
    }

    if(nextProps.fixOrdTbleData !== this.props.fixOrdTbleData){
      this.setState({ loadtableflag: false });
      this.setState({ isRefreshDisabled : false });
      this.setState({reportsRowsCount:nextProps.fixOrdTbleData.length});
    }
  // if(nextProps.loadRptFlag !== this.state.loadtableflag){
  //     this.setState({ loadtableflag: false });
  //     this.setState({ isRefreshDisabled : false });
  //   }
    if(nextProps.defAcc !== this.props.defAcc){
      this.setState({selectedAccountName: nextProps.defAcc.AD});
      this.setState({selectedAccount:nextProps.defAcc.AC})
    }
  }


  onChangeAccount = (text,key) => {
    try {
      this.setState({selectedAccountName: text});
      this.setState({selectedAccount:key});
      if (this.props.DFA.C !== key) {
        defAccFlag = false;
        this.setState({AccFlag: false});
        //this.setState(defAccFlag:false);
      } else {
        defAccFlag = true;
        this.setState({AccFlag: true});
      }
      this.setState({ loadtableflag: true });
      this.props.loadFixingReport(this.state.selectedFixingCode,moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'),this.state.selectedCmdtyId,this.state.orderTypeKey,this.state.fixEventTimeKey, key,this.state.createdByKey,this.state.qty_type,this.state.fixDateType);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeAccount', component:"FixingOrdersReport"});
    }
  }

  cmdtySelection=(cmdtyId,cmdtyDes)=>{
    try{
      this.setState({
        selectedCmdtyId:cmdtyId,
        selectedCmdty:cmdtyDes
      });
      this.props.loadFixingReport(this.state.selectedFixingCode,moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'),cmdtyId,this.state.orderTypeKey,this.state.fixEventTimeKey, this.state.selectedAccount,this.state.createdByKey,this.state.qty_type,this.state.fixDateType);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'cmdtySelection', component:"FixingOrdersReport"});
    }
  }

  fixingSelection = (fixingDet) =>{
    try{
      // console.log("fixingDet "+JSON.stringify(fixingDet));
      if (fixingDet.IID.length !== 0) {
        this.setState({
          cmdtyList:fixingDet.IID,
          selectedCmdtyId:fixingDet.IID[0].ID,
          selectedCmdty:fixingDet.IID[0].DESC,
          selectedFixing:fixingDet.FN,
          selectedFixingCode:fixingDet.FC,
          selectedFixingTime:fixingDet.FT
        });
        this.props.loadFixingReport(fixingDet.FC,moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'),fixingDet.IID[0].ID,this.state.orderTypeKey,this.state.fixEventTimeKey, this.state.selectedAccount,this.state.createdByKey,this.state.qty_type,this.state.fixDateType);
      } else {
        this.setState({
          cmdtyList:fixingDet.IID,
          selectedCmdtyId: '',
          selectedCmdty: '',
          selectedFixing:fixingDet.FN,
          selectedFixingCode:fixingDet.FC,
          selectedFixingTime:fixingDet.FT
        });
        this.props.loadFixingReport(fixingDet.FC,moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'),fixingDet.IID,this.state.orderTypeKey,this.state.fixEventTimeKey, this.state.selectedAccount,this.state.createdByKey,this.state.qty_type,this.state.fixDateType);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'fixingSelection', component:"FixingOrdersReport"});
    }
  }

  setStartDate = startDate => {
    try{
      this.setState({ startDate:startDate});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setStartDate', component:"FixingOrdersReport"});
    }
  }

  setEndDate = endDate => {
    try{
      this.setState({ endDate:endDate });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setEndDate', component:"FixingOrdersReport"});
    }
  }


  onChnageQtyType = (stk_code) => {
    try{
      this.setState({qty_type: stk_code});
      this.setState({ qtyTypeColName:stk_code });
      this.setState({ loadtableflag: true });
      this.props.loadFixingReport(this.state.selectedFixingCode,moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'),this.state.selectedCmdtyId,this.state.orderTypeKey,this.state.fixEventTimeKey, this.state.selectedAccount,this.state.createdByKey,stk_code,this.state.fixDateType);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChnageQtyType', component:"FixingOrdersReport"});
    }
  }

  closeValidationModal=()=>{
    try{
      this.setState({validationFlag :false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeValidationModal', component:"FixingOrdersReport"});
    }
  }

  onChangeOrderType = (text,value) => {
    try{
      this.setState({orderType: text});
      this.setState({orderTypeKey:value});
      this.setState({orderTypeKey:value});
      var fixEventTimeKey='';
      var orderTypeKey=value;
      var fixDateType= value === 'O'? this.state.fixDateType : "ALL";
      if(value==='O'){
        this.setState({fixEventTime:'outstanding'});
        this.setState({fixEventTimeKey:''});
        fixEventTimeKey='';
      }
      if(value==='F'){
        this.setState({fixEventTime:"filledTime"});
        this.setState({fixEventTimeKey: "F"});
        fixEventTimeKey="F";
      }
      if(value==='C'){
        this.setState({fixEventTime:"cancelledTime"});
        this.setState({fixEventTimeKey: "C"});
        fixEventTimeKey="C";
      }
      this.setState({fixingDateTypeHeading:'all'});
      this.setState({fixDateType:"ALL"});
      this.setState({ loadtableflag: true });
      this.props.loadFixingReport(this.state.selectedFixingCode, value ==='O' ? moment(new Date()).format('DD-MM-YYYY') : moment(this.state.startDate).format('DD-MM-YYYY'),  value ==='O' ? moment(new Date()).format('DD-MM-YYYY') : moment(this.state.endDate).format('DD-MM-YYYY'),this.state.selectedCmdtyId,orderTypeKey,fixEventTimeKey, this.state.selectedAccount,this.state.createdByKey,this.state.qty_type,fixDateType);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeOrderType', component:"FixingOrdersReport"});
    }
  }

  fixEventTime = (text,key) => {
    try{
      this.setState({fixEventTime: text});
      this.setState({fixEventTimeKey: key});
      this.setState({ loadtableflag: true });
      this.props.loadFixingReport(this.state.selectedFixingCode,moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'),this.state.selectedCmdtyId,this.state.orderTypeKey,key, this.state.selectedAccount,this.state.createdByKey,this.state.qty_type,this.state.fixDateType);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'fixEventTime', component:"FixingOrdersReport"});
    }
  }

  onChangeCreatedBy = (text,key) => {
    try{
      this.setState({createdBy: text});
      this.setState({createdByKey:key});
      this.setState({ loadtableflag: true });
      this.props.loadFixingReport(this.state.selectedFixingCode,moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'),this.state.selectedCmdtyId,this.state.orderTypeKey,this.state.fixEventTimeKey, this.state.selectedAccount,key,this.state.qty_type,this.state.fixDateType);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeCreatedBy', component:"FixingOrdersReport"});
    }
  }

  onChangeSearchValue(value){
    try{
      this.setState({searchValue: value });
      var count=this.state.orderTypeKey==='O'? getCountofTableRows(this.props.fixOrdTbleData,this.state.Outstandingcols,value)
      : this.state.orderTypeKey==='F'? getCountofTableRows(this.props.fixOrdTbleData,this.state.Filledcols,value)
      :this.state.orderTypeKey==='C'? getCountofTableRows(this.props.fixOrdTbleData,this.state.Cancelledcols,value)
      :getCountofTableRows(this.props.fixOrdTbleData,this.state.Allcols,value);
      this.setState({reportsRowsCount:count});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeSearchValue', component:"FixingOrdersReport"});
    }
  }

  onChangeHiddenOutstandingTableCol(hiddenCol){
    try{
      this.setState({ HiddenOutstandingTableCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenOutstandingTableCol', component:"FixingOrdersReport"});
    }
  };

  onChangeHiddenFillTableCol(hiddenCol){
    try{
      this.setState({ HiddenFillTableCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenFillTableCol', component:"FixingOrdersReport"});
    }
  };

  onChangeHiddenCancelledTableCol(hiddenCol){
    try{
      this.setState({ HiddenCancelledTableCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenCancelledTableCol', component:"FixingOrdersReport"});
    }
  };

  generatePdf=(format)=>{
    try{
      if(this.props.fixOrdTbleData.length === 0 || this.props.fixOrdTbleData === '' || this.props.fixOrdTbleData === null){
        this.setState({showRptDialog:true});
      }else{
      this.setState({showRptDialog:false});
      this.props.generateFixReportPdf(this.state.selectedFixingCode,moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'),this.state.orderTypeKey,this.state.fixEventTimeKey, this.state.selectedAccount,this.state.createdByKey,this.state.qty_type,this.state.selectedAccountName,format,this.state.fixDateType,this.state.orderTypeKey,this.state.selectedAccount,this.state.selectedCmdtyId);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'generatePdf', component:"FixingOrdersReport"});
    }
  }

  changeFlag = () => {
    try{
      this.setState({showRptDialog: true});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeFlag', component:"FixingOrdersReport"});
    }
  }
  closeRptModal = (event) => {
    try{
      this.setState({showRptDialog: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeRptModal', component:"FixingOrdersReport"});
    }
  }
  onFixingDateType = (value,text) => {
    try{
      this.setState({fixDateType:value});
      this.setState({fixingDateTypeHeading:text});
      this.setState({ loadtableflag: true });
      this.props.loadFixingReport(this.state.selectedFixingCode,moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'),this.state.selectedCmdtyId,this.state.orderTypeKey,this.state.fixEventTimeKey, this.state.selectedAccount,this.state.createdByKey,this.state.qty_type,value);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onFixingDateType', component:"FixingOrdersReport"});
    }
  }
  afterOpenModal() {
    try{
      const thisComponent = this.refs.errorMSG;
      ////const allCssStyleRules = this.props.selectedCssColorTheme;
      const elementsData = [
        {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
        {"classNames":"button-l","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      ];
      // applyStyle(thisComponent, allCssStyleRules, elementsData);
      const directionData = [
        {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"button-l","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      ];
      setDirection(thisComponent,directionData,this.props.selectedLang);
      const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
        {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},

      ];
      // //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"FixingOrdersReport"});
    }
  }

  render() {
    const {selectedCmdty, orderTypeKey, selectedAccountName, orderType, createdBy, COM, fixEventTime,fixingDateTypeHeading}=this.state;

    var cmdtyLable='';
	  if(COM === 1){
         cmdtyLable  = i18next.t('quantity');
     }else {
        cmdtyLable  = i18next.t('quantity') +" "+ "("+this.state.qtyTypeColName+")";
    }

    const Outstandingcols = [
      {name:'p_user_code', title:i18next.t('placedBy'), width:{wpx: 110}},
      {name:'orderNo', title:i18next.t('orderNo'), width:{wpx:150}},
      {name:'fixingDate', title:i18next.t('fixingDate'), width:{wpx:100}},
      {name:'fixingEvent', title:i18next.t('fixingEvent'), width:{wpx:150}},
      {name:'deal_type', title:i18next.t('deal'), width:{wpx:110}},
      {name:'cmdtyPair', title:i18next.t('cmdtyPair'), width:{wpx:80}},
      {name:'qty', title:i18next.t('qty'), align:'right', width:{wpx:110}},
      {name:'ord_stk_code', title: i18next.t('qtyType'), width:{wpx:80}},
      {name:'remarks', title:i18next.t('comments'), width:{wpx:250}},
    ];

    const Filledcols = [
      {name:'p_user_code', title:i18next.t('placedBy'), width:{wpx:110}},
      {name:'orderNo', title:i18next.t('orderNo'), width:{wpx:150}},
      {name:'fixingEvent', title:i18next.t('fixingEvent'), width:{wpx:100}},
      {name:'deal_type', title:i18next.t('deal'), width:{wpx:85}},
      {name:'cmdtyPair', title:i18next.t('cmdtyPair'), width: {wpx:80}},
      {name:'filledTime', title:i18next.t('filledTime'), width:{wpx:110}},
      {name:'filledQty', title: i18next.t('filledQty'), align:'right', width:{wpx:80}},
      {name:'ord_stk_code', title: i18next.t('qtyType'), width:{wpx:80}},
      {name:'user_code', title: i18next.t('filledBy'), width:{wpx:80}},
      {name:'price', title:i18next.t('price'), align:'right', width:{wpx:110}},
      {name:'docNo', title:i18next.t('docNo'), width:{wpx:150}},
      {name:'remarks', title:i18next.t('comments'), width:{wpx:400}}
    ];

    const Cancelledcols = [
      {name:'p_user_code', title:i18next.t('placedBy'), width:{wpx:110}},
      {name:'orderNo', title:i18next.t('orderNo'), width:{wpx:150}},
      {name:'fixingEvent', title:i18next.t('fixingEvent'), width:{wpx:100}},
      {name:'deal_type', title:i18next.t('deal'), width:{wpx:85}},
      {name:'cmdtyPair', title:i18next.t('cmdtyPair'), width:{wpx:80}},
      {name:'cancelledTime', title:i18next.t('cancelledTime'), width:{wpx:110}},
      {name:'cancelledQty', title: i18next.t('cancelledQty'), align:'right', width:{wpx:80}},
      {name:'ord_stk_code', title: i18next.t('qtyType'), width:{wpx:80}},
      {name:'user_code', title: i18next.t('cancelledBy'), width:{wpx:80}},
      {name:'remarks', title:i18next.t('comments'), width:{wpx:110}},
    ];

    var tableDataOut = [];
    var tableDataFill = [];
    var tableDataCan = [];
    var propData = this.props.fixOrdTbleData;

    for(let i=0;i<propData.length;i++){
      tableDataCan[i] = [{value: propData[i].p_user_code, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].orderNo, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].fixingEvent, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].deal_type, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].cmdtyPair, style: {alignment: {wrapText: true,horizontal:"left"}}} , {value: propData[i].cancelledTime, style: {alignment: {wrapText: true,horizontal:"left"}}} , {value: propData[i].cancelledQty, style: {alignment: {wrapText: true,horizontal:"right"}}},{value: propData[i].ord_stk_code, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].user_code, style: {alignment: {wrapText: true,horizontal:"left"}}} ,{value: propData[i].remarks, style: {alignment: {wrapText: true,horizontal:"left"}}}];
    }

    for(let i=0;i<propData.length;i++){
      tableDataOut[i] = [{value: propData[i].p_user_code, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].orderNo, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].fixingDate, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].fixingEvent, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].deal_type, style: {alignment: {wrapText: true,horizontal:"left"}}} , {value: propData[i].cmdtyPair, style: {alignment: {wrapText: true,horizontal:"left"}}} , {value: propData[i].qty, style: {alignment: {wrapText: true,horizontal:"right"}}},{value: propData[i].ord_stk_code, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].remarks, style: {alignment: {wrapText: true,horizontal:"left"}}}];
    }

    for(let i=0;i<propData.length;i++){
      tableDataFill[i] = [{value: propData[i].p_user_code, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].orderNo, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].fixingEvent, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].deal_type, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].cmdtyPair, style: {alignment: {wrapText: true,horizontal:"left"}}} , {value: propData[i].filledTime, style: {alignment: {wrapText: true,horizontal:"left"}}} , {value: propData[i].filledQty, style: {alignment: {wrapText: true,horizontal:"right"}}},{value: propData[i].ord_stk_code, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].user_code, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].price, style: {alignment: {wrapText: true,horizontal:"right"}}},{value: propData[i].docNo, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].remarks, style: {alignment: {horizontal:"left"}}}];
    }

    let multiDataSetOut = [{
      columns: Outstandingcols,
      data: tableDataOut
    }];

    let multiDataSetFill = [{
      columns: Filledcols,
      data: tableDataFill
    }];

    let multiDataSetCan = [{
      columns: Cancelledcols,
      data: tableDataCan
    }];
    const FillOrdersCell = props => {
      const { column } = props;
      if(column.name === "pcs_qty" || column.name === "price1"){
        return <Table.Cell {...props} className="textAlignLeft" />;
      }
      return <Table.Cell {...props} />;
    };

    const OutOrdersCell = props => {
      const { column } = props;
      if(column.name === "pcs_qty" || column.name === "price1"){
        return <Table.Cell {...props} className="textAlignLeft" />;
      }
      return <Table.Cell {...props} />;
    };

    const Cell = props => {
      const { column } = props;
      if(column.name === "pcs_qty" || column.name === "price1"){
        return <Table.Cell {...props} className="textAlignLeft" />;
      }
      return <Table.Cell {...props} />;
    };

    const pagingPanelMessages = {
      showAll: i18next.t(('all')),
      rowsPerPage: i18next.t('rowsPerPage'),
      info:'',
    };

    const searchPlaceholderMsg = {
      searchPlaceholder: i18next.t(('search'))+'...',
    };

    const PagingContainer = props => (
      <PagingPanel.Container {...props} className="pagingPanelDiv" />
    );

    const PagingContainerdark = props => (
      <PagingPanel.Container {...props} className="pagingPanelDivDark" />
    );

    const rowStyle = theme => ({
      tableStriped: {
        '& tbody tr:nth-of-type(odd)': {
          //backgroundColor: this.props.selectedCssColorTheme.listRow.background,
          //color:this.props.selectedCssColorTheme.listRow.color
        },
        '& tbody tr:nth-of-type(even)': {
          // backgroundColor: this.props.selectedCssColorTheme.rptListRowNext.background,
          // color:this.props.selectedCssColorTheme.listRow.color
        },
        '& thead th': {
          ////color:this.props.selectedCssColorTheme.tableHeaderColor.color
        },
        '& .text-primary': {
          ////color: this.props.selectedCssColorTheme.activeHeaderColor.color
        }
      },
    });

    var NoDataMsg = {
      noData: '',
    }
    if (this.state.loadtableflag === true) {
      NoDataMsg.noData = '';
    } else {
      NoDataMsg.noData = i18next.t("noDataAvlMsg");
    }

    const NoDataCell = props => (
      <Table.NoDataCell {...props} className="noDataCell"  />
    );

    const dropDownListColor =theme =>({
      dropDownListHoverMenu:{
        '& .dropdown-item':{
          // background:this.props.selectedCssColorTheme.dropDownList.background,
          // color:this.props.selectedCssColorTheme.dropDownList.color
        },
        '& :hover':{
          // background:this.props.selectedCssColorTheme.dropDownListHover.background,
          // color:this.props.selectedCssColorTheme.dropDownListHover.color
        },
        '& .popover':{
          //background:this.props.selectedCssColorTheme.dropDownListHover.background
        }
      }
    });

    const TableComponentBase = ({ classes, ...restProps }) => (
      <Table.Table
        {...restProps}
        className={classes.tableStriped}
      />
    );

    const ContainerColor = ({ classes, ...restProps }) => (
      <ColumnChooser.Container {...restProps} className={classes.dropDownListHoverMenu} />
    );
    const MenuColor = props => (
      <ColumnChooser.Item {...props} />
    );
      if (orderTypeKey === 'O') {
        fileName = "Outstanding Fixing Order Report";
      }
      else if (orderTypeKey === 'F') {
        fileName = "Filled Fixing Order Report";
      }
      else if (orderTypeKey === 'C') {
        fileName = "Cancelled Fixing Order Report";
      }
      else if (orderTypeKey === 'A') {
        fileName = "All Fixing Order Report";
      }
    return (
      <React.Fragment>
        <div className={`${this.props.language}`}>
          <Modal className={styles.warningModal} isOpen={this.state.validationFlag} onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.header} header`} >{i18next.t("error")}
                <span className={`${styles.closeImg} closeIcon`} onClick={this.closeValidationModal}>
                  {this.props.closeIcon}
                </span>
              </div>
              <div className={`${styles.msg} commonMsgDir`} >
                <h4>{i18next.t("dateSelectorErrMsg")}</h4>
              </div>
            </div>
          </Modal>
          <Modal isOpen={this.state.showRptDialog} className={styles.warningModal} id="orlHistModal" onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.header} rptModalHeader header`} >
                <span className={`${styles.msgTitle}`}>{i18next.t('Fixing Order Report')}</span>
                <span onClick={this.closeRptModal} className={`${styles.closeImg} closeIcon`} id="orlHistCloseIcon">{this.props.closeIcon}</span>
              </div>
              <div className={`${styles.msg} commonMsgDir`} style={this.props.selectedCssColorTheme.rptModalMsg}>
                {i18next.t('noDataAvlMsg')}
              </div>
              <div className={`${styles.btnWrap} col-md-12`}>
                  <Button className='button-l' bsStyle="primary" onClick={this.closeRptModal} id="orlHistCloseBtn" >{i18next.t('OK')}</Button>
              </div>
            </div>
          </Modal>

          <div className={`${styles.onlinefilterBar} onlinefilterBar`}>
            <div className={`${styles.onlinefilterBarInner} fltrBarInner`}>
                <div className={styles.optionsWrapper}>
                    <div id="onlineOrdAcclist" name="onlineOrdAcclist" className={`${styles.wrapper1} onlDrpdownDiv`}>
                        <DropdownButton id="bg-nested-dropdown" className={`${styles.onlineAccount} reportsDropdown btnText`} title={i18next.t(this.state.selectedAccountName)}>
                        {this.state.accountList.map((item) =>{
                            return (
                            <MenuItem id="onlOrdAccListMenu" onClick={() => this.onChangeAccount(item.D, item.C)}>{item.D}</MenuItem>
                            );
                        })}
                        </DropdownButton>
                    </div>

                    <div id="onlineOrdOption" name="onlineFixingEvents" className={`${styles.onlinefilterOptions} onlDrpdownDiv`}>
                        <DropdownButton id="fixingEvent" className="form-control trdDropDown btnText" title={this.state.selectedFixing} >
                        {this.props.fixingEvents.map((item,index) => {
                            // console.log("this.props.fixingEvents" + JSON.stringify(this.props.fixingEvents));
                            return (
                            <MenuItem eventKey={item.FC} onClick={()=>this.fixingSelection(item)}>{item.FN}</MenuItem>
                            );
                        })}
                        </DropdownButton>
                    </div>

                    <div id="onlineOrdOption" name="onlineCmdtyPairs" className={`${styles.onlinefilterOptions} onlDrpdownDiv`}>
                        <DropdownButton className={`${styles.cmdtyPairtrdDropDown} form-control trdDropDown btnText`} title={selectedCmdty}>
                        {this.state.cmdtyList.map((item,index) => {
                        return (
                        <MenuItem eventKey={item.ID} onClick={()=>this.cmdtySelection(item.ID, item.DESC)}>{item.DESC}</MenuItem>
                        );
                        })}
                        </DropdownButton>
                    </div>

                    <div id="onlineOrdOption" name="onlineOrdStatus" className={`${styles.onlinefilterOptions} onlDrpdownDiv`}>
                        <DropdownButton id="bg-nested-dropdown" className="reportsDropdown btnText" title={i18next.t(orderType)}>
                        <MenuItem id="onlOrdOtstng" onClick={() => this.onChangeOrderType("outstanding", "O")}>{i18next.t("outstanding")}</MenuItem>
                        <MenuItem id="onlOrdFilled" onClick={() => this.onChangeOrderType("filled", "F")}>{i18next.t("filled")}</MenuItem>
                        <MenuItem id="onlOrdCancelled" onClick={() => this.onChangeOrderType("cancelled", "C")}>{i18next.t("cancelled")}</MenuItem>
                        </DropdownButton>
                    </div>
                    {orderTypeKey === 'O'?
                        <div id="onlineOrdFltItem" name="onlineDateFltr" className={`${styles.filterItem} onlDrpdownDiv`}>
                        <DropdownButton id="bg-nested-dropdown" className={`${styles.filterItembtn} reportsDropdown btnText`} title={i18next.t(fixingDateTypeHeading)}>
                            <MenuItem id="onlOrdAll" onClick={() => this.onFixingDateType("ALL","All")}>{i18next.t("all")}</MenuItem>
                            <MenuItem id="onlOrdToday" onClick={() => this.onFixingDateType("T","Today")}>{i18next.t("today")}</MenuItem>
                        </DropdownButton>
                        </div>
                    :null}
                    {/*}{orderTypeKey === 'O' ?
                        <div id="onlineOrdItem" className={`${styles.onlinefilterItem} onlDrpdownDiv`}>
                        <DropdownButton id="bg-nested-dropdown" className="reportsDropdown btnText"  disabled>
                            <MenuItem id="onlOrdEvntCreatedTime"  onClick={()  => this.fixEventTime("createdTime", "D")}>{i18next.t("createdTime")}</MenuItem>
                        </DropdownButton>
                        </div>
                    : null}*/}

                    {orderTypeKey === 'F' ?
                        <div id="onlineOrdItem" name="timeFltr" className={`${styles.onlinefilterItem} onlDrpdownDiv`}>
                        <DropdownButton id="bg-nested-dropdown" className="reportsDropdown btnText"  title={i18next.t(fixEventTime)}>
                            <MenuItem id="onlOrdEvntFilledTime"  onClick={() => this.fixEventTime("filledTime", "F")}>{i18next.t("filledTime")}</MenuItem>
                            <MenuItem id="onlOrdEvntCreatedTime"  onClick={()  => this.fixEventTime("createdTime", "D")}>{i18next.t("createdTime")}</MenuItem>
                        </DropdownButton>
                        </div>
                    : null}

                    {orderTypeKey === 'C' ?
                        <div id="onlineOrdItem" name="timeFltr" className={`${styles.onlinefilterItem} onlDrpdownDiv`}>
                        <DropdownButton id="bg-nested-dropdown" className="reportsDropdown btnText"  title={i18next.t(fixEventTime)}>
                            <MenuItem id="onlOrdEvntCancelTime"  onClick={() => this.fixEventTime("cancelledTime", "C")}>{i18next.t("cancelledTime")}</MenuItem>
                            <MenuItem id="onlOrdEvntCreatedTime"  onClick={()  => this.fixEventTime("createdTime", "D")}>{i18next.t("createdTime")}</MenuItem>
                        </DropdownButton>
                        </div>
                    : null}
                    {orderTypeKey === 'C' || orderTypeKey === 'F' ?
                    <div id="fixOrdSelectDate" name="fixOrdSelectDate" className={`${styles.selectFixDatebtn} onlDrpdownDiv`}>
                        <DateSelector
                        keyValue={this.state.keyValue}
                        onClickFilter={this.getValidFixingEvents}
                        setStartDate={this.setStartDate}
                        setEndDate={this.setEndDate}
                        component='Report'
                        />
                    </div>:null}
                    <div id="onlineOrdFltItem" name="createdByFltr" className={`${styles.filterItem} onlDrpdownDiv`}>
                        <DropdownButton id="bg-nested-dropdown" className={`${styles.filterItembtn} reportsDropdown btnText`} title={i18next.t(createdBy)}>
                        <MenuItem id="onlOrdAll" onClick={() => this.onChangeCreatedBy("createdByAll", "2")}>{i18next.t("createdByAll")}</MenuItem>
                        <MenuItem id="onlOrdMe" onClick={() => this.onChangeCreatedBy("me", "0")}>{i18next.t("me")}</MenuItem>
                        <MenuItem id="onlOrdOthers" onClick={() => this.onChangeCreatedBy("others", "1")}>{i18next.t("others")}</MenuItem>
                        </DropdownButton>
                    </div>
                </div>
                <div className={styles.exportOptions}>
                    <div className={`${styles.exportfileBaracc} allExportFilter`}>
                        <div id="onlGobtn" className="commonGoBtn">
                            <button type="button" id="onlOrdRefreshBtn" className={this.state.isRefreshDisabled === true ? `${styles.disabled} ${styles.goBtn}` : `${styles.goBtn}`} onClick={this.getValidFixingEvents}>
                                {this.props.refreshIcon}
                            </button>
                        </div>

                        <label className={this.state.loadtableflag === true ? "disableLabel" : null}>
                        {(this.props.fixOrdTbleData.length !== 0) &&
                            <span>
                            <ExcelFile  filename={fileName} element={(<img src="/images/xls.png"/>)}>
                                {orderTypeKey === 'O' ? <ExcelSheet dataSet={multiDataSetOut} name="FixingOrderReport" />
                                : orderTypeKey === 'F' ? <ExcelSheet dataSet={multiDataSetFill} name="FixingOrderReport" />
                                : orderTypeKey === 'C' ? <ExcelSheet dataSet={multiDataSetCan} name="FixingOrderReport" />
                                : null}
                            </ExcelFile>
                            </span>
                        }
                        {(this.props.fixOrdTbleData.length === 0) && <img src="/images/xls.png" onClick={this.changeFlag} />}
                        <span><img src="/images/pdf.png" onClick={()=>{this.generatePdf("PDF")}} id="fixOrdPDF" /></span>
                        </label>
                    </div>
                </div>
            </div>
          </div>

          <div id="onlineOrdTable" className={`${styles.onlineOrdTable} onlineOrdTable reportTblBg`}>
          {this.state.loadtableflag === true ?
            <div className={styles.rptoverlay} >
              <i className="fa fa-spinner fa-spin spin-big"></i>
            </div>
          : null}

          {orderTypeKey === 'O' ?
            <div className={`${styles.OnlineOrderOutstandingTable} reportsTblGrid`} >
              <Grid rows={this.props.fixOrdTbleData} columns={Outstandingcols}>
                <SortingState defaultSorting={[{columnName:'docno', direction:'desc'}]} />
                <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                {this.state.reportsRowsCount > 10 && this.props.selectedCssColor !== "DR" ?
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                : this.state.reportsRowsCount > 10 && this.props.selectedCssColor === "DR" ?
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                : null}
                {this.state.reportsRowsCount > 10 ? <IntegratedPaging /> : null}
                <SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue} />
                <IntegratedFiltering />
                <Table tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)} columnAutoWidth={true} columnExtensions={this.state.integratedSortingColumnExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell} cellComponent={OutOrdersCell} />
                <TableHeaderRow showSortingControls id="ordertbl" />
                <TableColumnVisibility columnExtensions={this.state.outLmtOrdColumnExtensions} hiddenColumnNames={this.state.HiddenOutstandingTableCol} onHiddenColumnNamesChange={this.onChangeHiddenOutstandingTableCol} />
                {this.state.reportsRowsCount > 10 && this.props.selectedCssColor !== "DR" ?
                  <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainer} />
                : this.state.reportsRowsCount > 10 && this.props.selectedCssColor === "DR" ?
                  <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainerdark} />
                : null}
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} autoComplete="new-password" />
                <ColumnChooser containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </div>
            // </Card>
          : null}

          {orderTypeKey === 'F' ?
            <div className={`${styles.OnlineOrderFillTable} reportsTblGrid`} >
              <Grid rows={this.props.fixOrdTbleData} columns={Filledcols}>
                <SortingState defaultSorting={[{columnName:'docno', direction:'desc'}]} />
                <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                {this.state.reportsRowsCount > 10 && this.props.selectedCssColor !== "DR" ?
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                :this.state.reportsRowsCount > 10 && this.props.selectedCssColor === "DR" ?
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                : null}
                {this.state.reportsRowsCount > 10 ? <IntegratedPaging /> : null}
                <SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue} />
                <IntegratedFiltering />
                <Table tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)} columnAutoWidth={true} columnExtensions={this.state.integratedSortingColumnExtensions} cellComponent={FillOrdersCell} messages={NoDataMsg} noDataCellComponent={NoDataCell} />
                <TableHeaderRow showSortingControls />
                <TableColumnVisibility hiddenColumnNames={this.state.HiddenFillTableCol} onHiddenColumnNamesChange={this.onChangeHiddenFillTableCol} />
                {this.state.reportsRowsCount > 10 && this.props.selectedCssColor !== "DR" ?
                  <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainer} />
                : this.state.reportsRowsCount > 10 && this.props.selectedCssColor === "DR" ?
                  <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainerdark} />
                : null}
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} autoComplete="new-password" />
                <ColumnChooser containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </div>
          : null}


          {orderTypeKey === 'C' ?
            <div className={`${styles.OnlineOrderCancelledTable} reportsTblGrid`} >
              <Grid rows={this.props.fixOrdTbleData} columns={Cancelledcols}>
                <SortingState defaultSorting={[{columnName:'docno', direction:'desc'}]} />
                <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                {this.state.reportsRowsCount > 10 && this.props.selectedCssColor !== "DR" ?
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                : this.state.reportsRowsCount > 10 && this.props.selectedCssColor === "DR" ?
                  <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                : null}
                {this.state.reportsRowsCount > 10 ? <IntegratedPaging /> : null}
                <SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue} />
                <IntegratedFiltering />
                <Table tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)} columnAutoWidth={true} columnExtensions={this.state.integratedSortingColumnExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell} cellComponent={Cell} />
                <TableHeaderRow showSortingControls />
                <TableColumnVisibility hiddenColumnNames={this.state.HiddenCancelledTableCol} onHiddenColumnNamesChange={this.onChangeHiddenCancelledTableCol} />
                {this.state.reportsRowsCount > 10 && this.props.selectedCssColor !== "DR" ?
                  <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainer} />
                : this.state.reportsRowsCount > 10 && this.props.selectedCssColor === "DR" ?
                  <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainerdark} />
                : null}
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} autoComplete="new-password" />
                <ColumnChooser containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </div>
          : null}

          </div>
        </div>
      </React.Fragment>
    );
  }
}
